import axios from "axios";
import React, { Component } from "react"

var Api_url = process.env.REACT_APP_API_URL;
console.log({ Api_url });

const axiosConfig = {
    headers: {
        "Content-Type": "application/json; text/html; charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
    },
};

export default class BulletinList extends Component {
    constructor() {
        super();
        this.state = {
            Records: [],
            LoadingFlag: false,
            TotalRecords: 0,
            FilePath: '',
            isOpen: false,
        }
    };

    async getAllRecords() {
        console.log("getAllRecords called ");
        var url = Api_url+'/api/files-list';
        console.log("url=" + url);
        var postData = {
            "UserInterface": 2,
            "WebFlag": true,
            "FileType": 1
        };
        this.setState({ LoadingFlag: true });
        console.log({ postData });
        await axios
            .post(url, postData, axiosConfig)
            .then((res) => {
                console.log("RESPONSE RECEIVED: ", res);
                console.log("res=" + JSON.stringify(res));

                var records = res.data.records;
                console.log({ records });
                var n1 = records.length;
                console.log("n1=" + n1);

                this.setState({ LoadingFlag: false, Records: records, TotalRecords: n1 });
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            });
    };

    componentDidMount() {
        console.log("componentDidMount called ");
        this.getAllRecords();
    }
    render() {
        return (
            <>

                <div className="team__area section-padding">
                    <div className="container">
                        <div className="row">
                            {this.state.LoadingFlag ? '' :
                                (this.state.TotalRecords > 0 ?
                                    this.state.Records.map((item, index) => (
                                        <div className="col-xl-4 col-lg-4 col-md-6 mb-30">
                                            <p>{item.UploadedFileName}</p>
                                            <a href={item.PdfViewerPath} target="_blank" rel="noopener noreferrer">View</a>
                                        </div>
                                    ))
                                    :
                                    ''
                                )
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

